///
/// EarthBrowser
///
/// Created by Matt Giger on 9/13/2026
/// Copyright (c) 2026 Geodata Labs
///
/// v38 -> v39: Add the one-time saved-view sync prompt flag to the
/// engagement slice (fires when an anonymous user saves their second view,
/// suggesting a free account so views follow them across devices).
///

export function migrateV38toV39(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	const engagement = (s.engagement && typeof s.engagement === "object")
		? s.engagement as Record<string, unknown>
		: {}
	if ("savedViewPromptShown" in engagement) return state

	return {
		...s,
		engagement: {
			...engagement,
			savedViewPromptShown: false,
		},
	}
}
